export const HELP_CENTER_URL = 'https://datalabs-jp.notion.site/Hatsuly-Help-Center-66c3998d14fa4255b7dce709249315f6';
export const GENERAL_CONTACT_URL = 'https://share.hsforms.com/11_hEhYjCR0CBEe1gX9adVQddydr';
export const SUBSCRIPTION_START_CONTACT_URL = 'https://share.hsforms.com/1gRWi5yhsTB-BBdsQsXeGIAddydr';
